import { render } from "./ExceptionNotification.vue?vue&type=template&id=0acdb2b6&ts=true"
import script from "./ExceptionNotification.vue?vue&type=script&lang=ts"
export * from "./ExceptionNotification.vue?vue&type=script&lang=ts"

import "./ExceptionNotification.vue?vue&type=style&index=0&id=0acdb2b6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__